import React from 'react';

export type LoadingPageBackground = 'background' | 'layer-01' | 'layer-02';

export interface LoadingPageProps {
  /** Background color variant (theme-aware) */
  backgroundColor?: LoadingPageBackground;
  /** Loading text to display */
  text?: string;
  /** Additional CSS classes */
  className?: string;
  /** Whether to show full page loading (true) or inline loading (false) */
  fullPage?: boolean;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({
  backgroundColor = 'background',
  text = 'Loading...',
  className = '',
  fullPage = true
}) => {
  const containerClass = fullPage 
    ? 'core-loading-page core-loading-page--full' 
    : 'core-loading-page core-loading-page--inline';

  // Map background variant to CSS variable
  const backgroundClass = `core-loading-page--bg-${backgroundColor}`;

  return (
    <div 
      className={`${containerClass} ${backgroundClass} ${className}`}
    >
      <div className="core-loading-page__content">
        <span className="core-loading-page__text">
          {text}
        </span>
      </div>
    </div>
  );
};
